const SCRIPT_SELECTOR = 'script[src*="/static/js/main."]';
const SCRIPT_REGEX = /src="([^"]*\/static\/js\/main\.[^"]+\.js)"/;

const fileName = (src) => (src ? src.split("/").pop() : null);

/** Build the running page was loaded with (CRA fingerprints main.<hash>.js). */
export const getRunningBuild = () =>
  fileName(document.querySelector(SCRIPT_SELECTOR)?.getAttribute("src"));

/** Build currently deployed on the server. */
export const getLatestBuild = async () => {
  const res = await fetch(`/index.html?_=${Date.now()}`, { cache: "no-store" });
  if (!res.ok) return null;
  const html = await res.text();
  return fileName(html.match(SCRIPT_REGEX)?.[1]);
};

/** Remove any service worker + caches left over from earlier deploys. */
export const clearStaleCaches = async () => {
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
  }
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  }
};

/** One-time cleanup of an old service worker; reloads once so the fresh build loads. */
export const cleanupOldServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return;
  const registrations = await navigator.serviceWorker.getRegistrations();
  if (registrations.length === 0) return;

  await clearStaleCaches();
  if (!sessionStorage.getItem("sw_cleaned")) {
    sessionStorage.setItem("sw_cleaned", "1");
    window.location.reload();
  }
};
